<template>
  <div class="formulir-section">
    <div class="card-holder">
      <v-card class="card-v">
        <div class="card-title d-flex flex-column align-center">
          <h2>FORMULIR PENDAFTARAN</h2>
          <p class="grey--text">Nomor: {{ siswa.sw_id }}/SMKRUS/PPDB/2020</p>
        </div>
        <div class="card-body">
          <div
            class="formulir-text-section d-flex flex-column align-center ma-5"
          >
            <div v-for="(field, index) in fields" :key="field.model">
              <div class="formulir-text mt-3" v-if="!field.childs">
                <div class="formulir-numb">{{ index + 1 }}.</div>
                <div>{{ field.name }}</div>
                <div>:</div>
                <div>{{ findModel(field) }}</div>
              </div>

              <div class="formulir-text mt-3" v-if="field.childs">
                <div class="formulir-numb">{{ index + 1 }}.</div>
                <div>{{ field.name }}</div>
                <div></div>
                <div></div>
              </div>

              <div class v-if="field.childs">
                <div
                  class="formulir-text formulir-text-child"
                  v-for="fieldChild in field.childs"
                  :key="fieldChild.model"
                >
                  <div></div>
                  <div class="pl-5">{{ fieldChild.name }}</div>
                  <div>:</div>
                  <div>{{ findModel(fieldChild) }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="formulir-image-section ma-5">
            <v-container grid-list-xs>
              <v-row alignment justify="center">
                <v-col
                  v-for="file in files"
                  :key="file.lmp_image"
                  xs="8"
                  sm="6"
                  md="4"
                  class="ma-5"
                  :class="
                    file.lmp_type != 'GAMBAR_ANIMASI' &&
                    file.lmp_type != 'PRESTASI'
                      ? ''
                      : 'hide'
                  "
                >
                  <div style="text-align: center">{{ file.lmp_type }}</div>

                  <div class="preview d-flex justify-center align-center">
                    <img
                      class="preview-image"
                      :src="`https://api-ppdb.smkruskudus.com/storage/${file.lmp_image}`"
                      alt="image"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </div>

          <div class="actions d-flex justify-center ma-5" v-if="role == 2">
            <v-btn color="error" class="ma-5" @click="rejectDialog = true"
              >Tolak Formulir</v-btn
            >
            <v-btn color="primary" class="ma-5" @click="acceptForm"
              >Terima Formulir</v-btn
            >
          </div>

          <div class="text-center">
            <v-dialog
              v-model="rejectDialog"
              max-width="700px"
              transition="dialog-transition"
              persistent
              scrollable
            >
              <v-card>
                <v-card-title class="grey lighten-2" primary-title
                  >Pilih Field Untuk Ditolak</v-card-title
                >

                <v-card-text style="max-height: 700px">
                  <v-container grid-list-xs id="dialogForm">
                    <v-select
                      :items="filesOption"
                      v-model="selectedFile"
                      label="Pilih Field"
                      multiple
                      chips
                      persistent-hint
                    ></v-select>
                  </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="primary" text @click="rejectDialog = false"
                    >Batal</v-btn
                  >
                  <v-btn
                    color="primary"
                    text
                    @click="submitRejection"
                    :disabled="!selectedFile"
                    >Kirim</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { EventBus } from "../event-bus";

export default {
  data: () => ({
    rejectDialog: false,
    models: "",
    fields: [
      { name: "No. Ujian Nas. SMP/MTs", model: "sw_no_ujian" },
      { name: "Nomor Induk Siswa Nasional (NISN)", model: "sw_nisn" },
      { name: "Nama Siswa (Lengkap)", model: "sw_nama_lengkap" },
      { name: "Pilihan Jurusan", model: "sw_jurusan" },
      { name: "Jenis Kelamin", model: "sw_gender" },
      { name: "Tempat dan Tanggal Lahir", model: "sw_ttl" },
      { name: "Agama", model: "sw_agama" },
      { name: "Alamat Siswa Sesuai KK", model: "sw_alamat" },
      {
        name: "Sekolah Asal",
        childs: [
          { name: "Nama Sekolah", model: "sw_sekolah_asal" },
          { name: "Alamat Sekolah", model: "sw_sekolah_asal_alamat" },
          {
            name: "Kabupaten/Kota Asal Sekolah",
            model: "sw_sekolah_asal_kabupaten",
          },
        ],
      },
      // {name: 'Raport', childs: [
      //   {name: 'Tahun', model: 'sw_agama'},
      // ]},
      { name: "Tinggi Badan", model: "sw_tinggi_badan" },
      { name: "Berat Badan", model: "sw_berat_badan" },
      {
        name: "Nama Orangtua",
        childs: [
          { name: "Ayah", model: "ot_nama_ayah", type: "ayah" },
          { name: "Ibu", model: "ot_nama_ibu", type: "ibu" },
        ],
      },
      // {
      //   name: "Alamat Orangtua (Lengkap)",
      //   model: "ot_alamat_ayah",
      //   type: "ayah"
      // },
      // {
      //   name: "Pekerjaan Orangtua",
      //   childs: [
      //     { name: "Ayah", model: "ot_pekerjaan_ayah", type: "ayah" },
      //     { name: "Ibu", model: "ot_pekerjaan_ibu", type: "ibu" }
      //   ]
      // },
      {
        name: "Nomor WhatsApp Aktif",
        childs: [
          { name: "Ayah", model: "ot_no_hp_ayah", type: "ayah" },
          { name: "Ibu", model: "ot_no_hp_ibu", type: "ibu" },
        ],
      },
      { name: "SPI (Sumbangan Pendidikan dan Infaq)", model: "sw_spi" },
      // { name: "Nama Wali", model: "ot_nama_wali", type: "wali" },
      // { name: "Alamat Wali (Lengkap)", model: "ot_alamat_wali", type: "wali" },
      // { name: "Pekerjaan Wali", model: "ot_pekerjaan_wali", type: "wali" }
    ],
    files: [],
    filesOption: [],
    selectedFile: "",
    role: "",
    sw_jurusan: "",
    siswa: {
      sw_id: "",
    },
  }),
  methods: {
    getData() {
      EventBus.$emit("startLoading");

      let sw_id = this.$route.params.id;
      this.siswa.sw_id = sw_id;
      axios
        .get(
          `${this.$api}/admin/detil-siswa?sw_id=${sw_id}&poiuytrewq=poiuytrewq`
        )
        .then((res) => {
          this.models = res.data.PAYLOAD.SISWA;
          var jsonAlamat = JSON.parse(this.models.sw_alamat);
          var alamatKK = `${jsonAlamat.kk.desa}, ${jsonAlamat.kk.kecamatan}, ${jsonAlamat.kk.kabupaten}, ${jsonAlamat.kk.provinsi}`;
          this.models.sw_alamat = alamatKK;

          res.data.PAYLOAD.ORTU.forEach((parentModel) => {
            for (let parentField in parentModel) {
              this.models = {
                ...this.models,
                [`${parentField}_${parentModel.ot_type.toLowerCase()}`]:
                  parentModel[parentField],
              };
            }
          });

          const files = res.data.PAYLOAD.LAMPIRAN.filter(
            (file) =>
              file.lmp_image !== "default.png" &&
              file.lmp_image !== "default2.png"
          );
          this.files = files;

          this.setFileSelectOption();
        });
    },
    findModel(field) {
      for (let model in this.models) {
        if (model === field.model) {
          const val = this.models[model];
          return val !== null && val !== undefined && val !== "" ? val : "-";
        }
      }
      return "-";
    },
    setFileSelectOption() {
      this.files.forEach((file) => {
        if (
          // file.lmp_type != "RAPORT" &&
          file.lmp_type != "PRESTASI" &&
          file.lmp_type != "GAMBAR_ANIMASI"
        ) {
          this.filesOption.push({ key: file.lmp_type, text: file.lmp_type });
          EventBus.$emit("stopLoading");
        }
      });
    },
    submitRejection() {
      EventBus.$emit("startLoading");

      let data = {
        sw_id: this.$route.params.id,
        type: "REJECT",
        lkjhgfdsa: "lkjhgfdsa",
      };

      let yesOrNo = "";
      let rejectedFile = "";

      this.files.forEach((file) => {
        rejectedFile = this.selectedFile.filter(
          (selected) => selected === file.lmp_type
        );

        yesOrNo = rejectedFile.length < 1 ? "Y" : "N";
        data = {
          ...data,
          [file.lmp_type]: yesOrNo,
        };
      });

      if (this.models["sw_jurusan"] == "Animasi") {
        data = {
          ...data,
          GAMBAR_ANIMASI: "Y",
        };
      }

      axios
        .post(`${this.$api}/admin/konfirmasi-lampiran`, data)
        .then((res) => {
          if (res.data.STATUS === "SUCCESS")
            this.$router.push({ name: "home" });

          EventBus.$emit("stopLoading");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    acceptForm() {
      EventBus.$emit("startLoading");

      axios
        .post(`${this.$api}/admin/konfirmasi-lampiran`, {
          sw_id: this.$route.params.id,
          type: "ACCEPT",
          lkjhgfdsa: "lkjhgfdsa",
        })
        .then((res) => {
          console.log("success");
          if (res.data.STATUS === "SUCCESS")
            this.$router.push({ name: "home" });

          EventBus.$emit("stopLoading");
        });
    },
  },
  mounted() {
    axios.defaults.headers.common = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          localStorage.clear();
          let hostDestination =
            window.location.hostname === "localhost"
              ? `localhost:${window.location.port}`
              : window.location.hostname;

          window.location.href = `http://${hostDestination}`;
        }
        return Promise.reject(error);
      }
    );
    this.role = localStorage.getItem("role");
    this.getData();
  },
};
</script>

<style scoped>
.hide {
  display: none;
}

.card-holder {
  width: 70%;
  margin: 100px auto;
}

.card-v {
  padding: 50px 0;
}

.formulir-text {
  display: grid;
  grid-template-columns: 50px 300px 20px 200px;
  grid-gap: 20px;
}

.formulir-numb {
  text-align: right;
}

.preview {
  border: 1px solid #374785;
  min-height: 200px;
  max-height: 300px;
  overflow: hidden;
  width: 100%;
}

.preview-image {
  width: 100%;
  height: auto;
}
</style>